<template>
  <div class="form-course-item">
    <div class="form-item-title">{{ column.label }}:</div>
    <div class="display-value">{{ column.value }}</div>
    <div class="form-item-content">
      <van-slider @change="onChange" :max="column.maxRows" v-model="column.value" />
      <div class="control">
        <i @click="handle2Change('-')" class="iconfont icon-stop"></i>
        <i @click="handle2Change('+')" class="iconfont iconshanchu2"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['column'],
  methods: {
    handle2Change(type) {
      if (type === '-') {
        if (this.column.value > this.column.minRows) {
          this.column.value--
        }
      }
      if (type === '+') {
        if (this.column.value < this.column.maxRows) {
          this.column.value++
        }
      }
    },
    onChange(value) {
      const params1 = this.column.prop
      const obj = {
        [params1]: value
      }
      this.$store.commit('setReport', obj)
    }
  }
}
</script>

<style scoped lang="scss">
.form-item-title {
  word-break: break-all;
}

.display-value {
  height: 40px;
  text-align: center;
  line-height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.form-item-content {
  display: flex;
  align-items: center;
  padding: 10px;

  .control {
    margin-left: 20px;
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    i {
      color: #999;
      font-size: 24px;
      display: inline-block;
    }
    i.iconshanchu2 {
      font-size: 22px;
      transform: rotate(45deg);
    }
  }
}
</style>
